export function toTitleCase(str: string | undefined | null) {
  if (!str) return str

  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase()
  )
}

export const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export function isValidEmailAddress(str: string): boolean {
  const match = str.trim().toLowerCase().match(EMAIL_VALIDATION_REGEX)
  return !!match
}

/**
 * Formats a LinkedIn URL or handle for display
 * @param url - The LinkedIn URL or handle
 * @param fallback - The fallback value if url is empty (default: '')
 * @returns The formatted LinkedIn URL
 */
export function formatLinkedInUrl(url: string | null | undefined, fallback: string = ''): string {
  if (!url) return fallback

  // If it already has the full URL format, return as is
  if (url.includes('linkedin.com/in/')) {
    return url
  }

  // Otherwise, it's just a handle, so add the prefix
  return `www.linkedin.com/in/${url}`
}
